import {FieldConfig} from '../../dynamic-field/field.config';
import {ChipItem} from '@mydocma/component-library/src/lib/chips/chip-item';
import {ChipListOptions} from '@mydocma/component-library/src/lib/chips/chip-list/chip-list-options';

export interface ChipsFieldConfig extends FieldConfig<ChipItem[]> {
    options?: ChipListOptions;
}
